
const productCardOverviewVideo = (productCard, handleOverlays) => {

  let overviewVideoButton = productCard.querySelector('.product-overview-video-button');
  let overviewVideoOverlay = productCard.querySelector('.product-overview-video-overlay');
  if(overviewVideoButton && overviewVideoOverlay) {

    let closeButton = overviewVideoOverlay.querySelector('.close-btn');
    let video = overviewVideoOverlay.querySelector('video');
    let videoDuration = 0; let timePlayed = 0; let maxTimePlayed = 0; let startVideoTimestamp = 0; // init all times at 0 milliseconds
    let minTrackingPlayTime = 3000; // Set minimum playback time for tracking (ms)

    // Find playback percentage for tracking
    const handlePlaybackTracking = () => {
      timePlayed = Date.now() - startVideoTimestamp;
      if(timePlayed > minTrackingPlayTime && timePlayed > maxTimePlayed) {
        maxTimePlayed = timePlayed;
        let maxPercentagePlayed = parseFloat(((maxTimePlayed / videoDuration) * 100).toFixed(2)); // Float %
        let playbackTrackingObj = {
          'product_title': overviewVideoOverlay.getAttribute('data-product-title'),
          'playback_time_ms': maxTimePlayed,
          'playback_percentage': maxPercentagePlayed
        };
        // Track playback percentage in GA
        if(window.gtag) {
          gtag('event', 'overview_video_playback_percentage', playbackTrackingObj);
        }
      }
    }

    // Open video overlay and play
    overviewVideoButton.addEventListener('click', e => {
      handleFixedElements('hide');
      overviewVideoOverlay.classList.add('active');
      // If video has already been loaded, play from start
      if(video.getAttribute('data-loaded') == 'true') {
        video.currentTime = 0;
        video.play();
        startVideoTimestamp = Date.now(); // Mark start time for measuring playback
      }
      // Else load video and then play
      else {
        let sourceEl = video.querySelector('source');
        sourceEl.src = sourceEl.dataset.src;
        video.load();
        video.addEventListener('loadeddata', function() {
          if(overviewVideoOverlay.classList.contains('active')) { // only if overlay hasn't been closed after clicking play
            video.currentTime = 0;
            video.play();
            videoDuration = Math.floor(video.duration * 1000); // capture video duration (ms) when loaded
            startVideoTimestamp = Date.now(); // Mark start time for measuring playback
          }
          video.setAttribute('data-loaded', 'true');
          // Track in GA (one per first load)
          if(window.gtag) {
            let productTitle = overviewVideoOverlay.getAttribute('data-product-title');
            let overviewVideoUrl = overviewVideoOverlay.getAttribute('data-overview-video-url');
            let pageUrl = window.location.href;
            gtag('event', 'overview_video_button_click', {
              'product_title': productTitle,
              'video_url': overviewVideoUrl,
              'from_page': pageUrl
            });
          }
        }, false);
      }
    });
    // Click video to pause
    video.addEventListener('click', e => {
      if(video.paused){
        video.play();
      } else {
        video.pause();
      }
    });
    // Click away of close button
    overviewVideoOverlay.addEventListener('click', e => {
      if (!e.target.closest('.modal') || e.target == closeButton){
        // Close modal handled by general overlay JS...
        handlePlaybackTracking();
      }
    });
    // Close video modal on video end
    video.addEventListener('ended', () => {
      overviewVideoOverlay.classList.remove('active');
      handlePlaybackTracking();
      handleFixedElements('show');
    })

    // Handle overlays for dynamically created cards
    if(handleOverlays) {
      handleOverlay(overviewVideoOverlay);
    }
  }
}

// Call for all loaded product cards
let productCards = document.querySelectorAll('.product-card').forEach((productCard) => productCardOverviewVideo(productCard));